module.exports = __webpack_public_path__ + "static/assets/19692175c86709b1ea47634df6066a9b.png";